export const FETCH_PERMISSION_TREE = 'permissions/FETCH_PERMISSION_TREE';
export const FETCH_PERMISSION_TREE_SUCCESS = 'permissions/FETCH_PERMISSION_TREE_SUCCESS';

export const SET_PERMISSION_TREE = 'permissions/SET_PERMISSION_TREE';

export const FETCH_BY_SID = 'permissions/FETCH_BY_SID';
export const FETCH_BY_SID_SUCCESS = 'permissions/FETCH_BY_SID_SUCCESS';
export const FETCH_BY_SID_ERROR = 'permissions/FETCH_BY_SID_ERROR';

export const FETCH_ACL_OBJECT_IDENTITIES = 'permissions/FETCH_ACL_OBJECT_IDENTITIES';
export const FETCH_ACL_OBJECT_IDENTITIES_SUCCESS = 'permissions/FETCH_ACL_OBJECT_IDENTITIES_SUCCESS';

export const FETCH_ACL_ENTITY_ID_TO_OID_INDEX = 'permissions/FETCH_ACL_ENTITY_ID_TO_OID_INDEX';
export const FETCH_ACL_ENTITY_ID_TO_OID_INDEX_SUCCESS = 'permissions/FETCH_ACL_ENTITY_ID_TO_OID_INDEX_SUCCESS';

export const FETCH_ACL_SIDS = 'permissions/FETCH_ACL_SIDS';
export const FETCH_ACL_SIDS_SUCCESS = 'permissions/FETCH_ACL_SIDS_SUCCESS';

export const FETCH_PERMISSIONS = 'permissions/FETCH_PERMISSIONS';
export const FETCH_PERMISSIONS_SUCCESS = 'permissions/FETCH_PERMISSIONS_SUCCESS';

export const SET_PERMISSIONS = 'permissions/SET_PERMISSIONS';

export const UPDATE = 'permissions/UPDATE';
export const UPDATE_SUCCESS = 'permissions/UPDATE_SUCCESS';

export const DELETE = 'permissions/DELETE';
export const DELETE_SUCCESS = 'permissions/DELETE_SUCCESS';

export const SET_EDITING_ROLE_ID = 'permissions/SET_EDITING_ROLE_ID';
export const SET_EDITING_SID = 'permissions/SET_EDITING_SID';
